export const LoginConfig = {
    // getter

    LOGIN_STATE: 'login_state',
    LOGIN_DATA: 'login_data',
    MAIN_DATA: 'main_data',

    OVER14_CHECKED: "over14_checked",
    AUTO_RETIRE_DATE: "auto_retire_date",

    MEMBER_DATA: 'member_data',
    MEMBER_NO: 'member_no',
    ACCESS_TOKEN: 'access_token',
    SNS_ACCESS_TOKEN: 'sns_access_token',

    GET_LOGOUT_DATA: 'getLogoutData',
    GET_FIND_ID_DATA: 'getFindIdData',
    GET_FIND_PW_DATA: 'getFindPwData',

    ORDER_ENABLED: 'orderEnabled',
    DELIVERY_ENABLED: 'deliveryEnabled',


    // Mutation
    LOGIN_EVENT: 'loginEvent', // 로그인
    LOGIN_DEVICE_EVENT: 'loginDeviceEvent', // 로그인 : 디바이스
    LOGOUT_EVENT: 'logoutEvent', // 로그 아웃

    JOIN_EVENT: 'join_event', // 회원가입

    FIND_ID_EVENT: 'findIdEvent', // 아이디 찾기
    SAVE_ID_EVENT : 'saveIdEvent',
    FIND_PW_EVENT: 'findPwEvent', // 패스워드 찾기

    KAKAO_LOGIN: 'kakaoLogin',
    KAKAO_LOGOUT: 'kakaoLogout',

    NAVER_LOGIN: 'naverLogin',
    NAVER_LOGOUT: 'naverLogout',

    GOOGLE_LOGIN: 'googleLogin',
    GOOGLE_LOGOUT: 'googleLogout',

    FACEBOOK_LOGIN: "facebookLogin",
    FACEBOOK_LOGOUT: "facebookLogout",

    // actions
    LOGIN_WITH_SNS_EVENT: 'login_with_sns_event',

    KAKAO_INIT:'init_kakao',
    REGIST_CI_EVENT:'regist_ci_event',
    MEMBER_INFO: "memberInfo",

    RESTORE_DORMANT: "restore_dormant"
}

export const UserInfoChangeConfig = {
    // getter


    // actions
    CHANGE_PW_EVENT: 'changePwEvent', // 패스워드 변경
    CHANGE_PW_EVENT2: 'changePwEvent2', // 패스워드 변경
    CHECK_NICKNAME_EVENT: 'checkNicknameEvent', // 닉네임 변경 중복 확인 버튼
    CHANGE_NICKNAME_EVENT: 'changeNicknameEvent', // 닉네임 변경
    CHANGE_USERINFO_EVENT: 'changeUserInfoEvent', // 개인 정보 수정
    CHANGE_PHONENUM_EVENT: 'changePhoneNumEvent', // 휴대폰 번호 변경

    CASH_RECEIPT_EVENT: 'cashReceiptEvent', // 현금 영수증 발급 정보
    CASH_RECEIPT_CHANGE_EVENT: 'cashReceiptChangeEvent', // 현금 영수증 발급 정보 변경

    CHANGE_AGREE_EVENT: 'changeAgreeEvent',
    CHANGE_LOCATION_EVENT: 'changeLocationEvent', // 위치정보 사용 동의
    CHANGE_PUSH_EVENT: 'changePushEvent', // PUSH 수신 동의
    CHANGE_SMS_EVENT: 'changeSmsEvent', // SMM 수신 동의
    CHANGE_EMAIL_EVENT: 'changeEmailEvent', // E-Mail 수신 동의

    MEMBER_RETIRE: "memberRetire" // 회원탈퇴
}

export const MemberShipConfig = {
    // Getters
    GET_INFO: 'getInfo',
    GET_CHECK_ID: 'getCheckId',
    GET_CHECK_NICKNAME: 'getCheckNickname',
    GET_AGREE_RESULT: 'getAgreeResult',

    // Mutation
    AGREE_ALL: 'agreeAll',
    AGREE_ONE: 'agreeOne',
    CHECK_ID: 'checkId',
    CHECK_NICKNAME: 'checkNickname',
    CLEAR_AGREE_INFO: 'clearAgreeInfo',
    CLEAR_USER_INFO: 'clearUserInfo'
}

export const OrderConfig = {

    CART_COUNT: 'order_cart_count',
    GET_CART_COUNT_EVENT: 'order_cart_count_event',
    //getter
    CATEGORIES: 'store_categores',

    ORDER_TYPE: 'order_type',
    SELECTED_ADDRESS: 'selected_address',
    SELECTED_STORE: 'selected_store',
    SELECTED_STORE_DETAIL: 'selected_store_detail',
    SELECTED_CATEGORY: 'selected_category',
    SELECTED_MENU: 'selected_menu',
    SELECTED_PRODUCT: 'selected_product',
    SELECTED_ITEM: 'selected_item',
    SELECTED_ITEM_OPTIONS: 'selected_item_options',

    GET_ORDER_STATE: 'getOrderState',

    // GET_DELIVERY_STATE: 'getDeliveryState',

    ORDER_DATA: 'order_data',
    // GET_DELIVERY_DATA: 'getDeliveryData',

    //mutations
    ORDER_RESULT: 'order_result',
    ORDER_PREPAY_RESULT: 'order_prepay_result',

    //actions
    INITIALIZE_ORDER_DATA: 'initialize_order_data',
    //
    ADD_CART_EVENT: 'accCart',

    //api actions
    ORDER_CART_EVENT: 'order_cart_event',
    ORDER_DIRECT_EVENT: 'order_direct_event',
    ORDER_CART_DIRECT_EVENT: 'order_cart_direct_event',
    ORDER_PAY_EVENT: 'order_pay_event',
    ORDER_PAY_COMPLETE_EVENT: 'order_pay_complete_event',
    ORDER_CANCEL_EVENT: 'order_cancel_event',
    GET_ORDER_HISTORY_LIST_EVENT: 'GET_ORDER_HISTORY_LIST_event',
    GET_ORDER_HISTORY_DETAIL_EVENT: 'get_order_history_detail_event',

    DELIVERY_CART_EVENT: 'delivery_cart_event',
    DELIVERY_DIRECT_EVENT: 'delivery_direct_event',
    DELIVERY_CART_DIRECT_EVENT: 'delivery_cart_direct_event',
    DELIVERY_PAY_EVENT: 'delivery_pay_event',
    DELIVERY_PAY_COMPLETE_EVENT: 'delivery_pay_complete_event',
    DELIVERY_CANCEL_EVENT: 'delivery_cancel_event',
    GET_DELIVERY_HISTORY_LIST_EVENT: 'get_delivery_history_list_event',
    GET_DELIVERY_HISTORY_DETAIL_EVENT: 'get_delivery_history_detail_event',
    EXTERNAL_GIFTS : 'external_gifts',
    EXTERNAL_GIFTS_RESULT : 'external_gifts_result'

}

export const GiftShopConfig = {

    CART_COUNT: 'giftshop_cart_count',
    GET_CART_COUNT_EVENT: 'giftshop_cart_count_event',

    GIFT_MAIN_DATA: 'gift_main_data',
    GIFT_EGIFT_ITEM_CATEGORY: 'gift_egift_item_category',
    GIFT_CARD_ITEM_CATEGORY: 'gift_card_item_category',

    GIFT_SELECTED_ITEM: 'gift_selected_item',

    GET_GIFT_MAIN_DATA_EVENT: 'get_gift_main_data_event',
    GET_GIFT_EGIFT_ITEM_CATEGORY_EVENT: 'get_gift_egift_item_category_event',
    GET_GIFT_CARD_ITEM_CATEGORY_EVENT: 'get_gift_card_item_category_event',

    // CART_ORDER_EVENT : ''

    //actions
    INITIALIZE_ORDER_DATA: 'initialize_gift_order_data',

}

export const PaymentConfig = {
    //getters/mutations
    PAY_ACTION: 'order',
    PAY_METHOD: 'payment_pay_method',
    PAY_MENU_TYPE: 'payment_pay_menu_type',
    ORDER_TYPE: 'payment_order_type',
    ORDER_DATA: 'payment_order_data',
    ORDER_STORE: 'payment_order_store',
    PRE_PAID_RESULT: 'payment_pre_paid_result',
    //actions
    INITIALIZE_PAYMENT_DATA: 'initialize_payment_data',

}

export const ShopConfig = {
    // getter
    CURRENT_VIEW: "getCurrentView",
    STORE_LIST: "getStoreList",
    SEARCH_TEXT: "getSearchText",
    SHOW_LOADING: "getShowLoading",
    TOTAL_SHOP_COUNT: "getTotalShopCount",

    // mutations
    SHOP_SEARCH_FORM: "shopSearchForm", // 빠른 검색 화면
    SHOP_NEAR_FORM: "shopNearForm", // 가까운 매장 화면
    SHOP_MY_FORM: "shopMyForm", // 나의 매장 화면

    // actions
    FETCH_SHOP_LIST: "fetchShopList", // 매장 조회
    FETCH_SHOP_SEARCH: "fetchShopSearch", // 매장명 또는 주소로 매장 조회
    FETCH_SHOP_NEAR: "fetchShopNear", // 가까운 거리의 매장 조회
    FETCH_SHOP_MY: "fetchShopMy", // 나의 매장 조회
    FETCH_SHOP_DETAIL: "fetchShopDetail", // 매장 상세 정보 조회
    INIT_SHOP_LIST: "initShopList", // 매장 조회 정보 초기화
    INIT_SHOP_ALL: "initShopAll", // 매장 조회 정보 초기화
    ADD_FAVORITE_STORE: "addFavoriteStore", // 나의 매장에 추가
    DELETE_FAVORITE_STORE: "deleteFavoriteStore", // 나의 매장에서 제거
    SHOW_LOADING: "showLoading" // 로딩 화면
}



// WEBPACK FOOTER //
// ./src/store/Constraints.js